import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import apis from "../api.js";
import { isAuthenticated, saveProfile } from "../auth.js";
import "./Login.css";

export default function Login(props) {
  document.title = props.title || "Login - Faster Payment System";

  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Do not call /me here — 401 when logged out is expected and clutters the console.
  // RequireAuth on protected routes still verifies the HttpOnly cookie via /me.
  if (isAuthenticated()) {
    return <Navigate to="/createQR" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await apis.login(username.trim(), password);
      if (!result.ok) {
        throw new Error(result.msg || "Login failed");
      }
      saveProfile({
        username: result.msg.username || username.trim(),
        role: result.msg.role,
      });
      navigate("/createQR", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={onSubmit}>
        <h1>FPS QR Code Generator</h1>
        <p className="login-subtitle">Sign in to continue</p>

        <label htmlFor="username">Username</label>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error ? <p className="login-error">{error}</p> : null}

        <button type="submit" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
